<div>
    <div class="input-group align-items-center">
        <span class="input-group-text bg-white border-0 p-0 rounded-start-pill height-50px">
            <app-action-button
                    (click)="!disabled() && resetView()"
                    [icon]="'fa-solid fa-crosshairs fa-xl'"
                    [loading]="loading()"
                    [disabled]="disabled()"
                    class="btn-sm p-2">
            </app-action-button>
        </span>

        <input #searchBar
            (input)="search($event.target)"
            (focus)="focus()"
            (blur)="blur()"
            class="form-control border-0 fs-main height-50px search-bar"
            placeholder="Search..."
            [disabled]="disabled()"
            type="search">

        <span class="input-group-text bg-white border-0 p-0 rounded-end-pill height-50px">
            <app-action-button
                    (click)="!disabled() && refresh()"
                    [icon]="'fa-solid fa-rotate-right fa-xl'"
                    [loading]="loading()"
                    [disabled]="!networkStatusStore.isOnline() || disabled()"
                    class="btn-sm p-2">
            </app-action-button>
        </span>
    </div>

    @if (filteredAssets().length + filteredDevices().length > 0 && showResults()) {
        <div>
            <div class="dropdown">
                <div class="dropdown-menu show w-100 max-height-vh30 overflow-y-auto">
                    @for (asset of filteredAssets(); track asset.id) {
                        <app-generic-button
                                (click)="selectAsset(asset)"
                                description="Select asset"
                                [alwaysShowText]="true"
                                [buttonText]="asset.name || asset.id"
                                [primaryIcon]="'fa-regular fa-compass fa-xl'"
                                class="dropdown-item">
                        </app-generic-button>
                    }
                    @for (device of filteredDevices(); track device.id) {
                        <app-generic-button
                                (click)="selectDevice(device)"
                                description="Select device"
                                [alwaysShowText]="true"
                                [buttonText]="device.name || device.id"
                                [primaryIcon]="'fa-regular fa-compass fa-xl'"
                                class="dropdown-item">
                        </app-generic-button>
                    }
                </div>
            </div>
        </div>
    }
</div>
